import type { ISEOFields } from '@/interfaces';
import { getNonWebpOgImageUrl } from '@/utils';
import { NextSeo } from 'next-seo';

const DocumentHead: React.FC<ISEOFields> = (data) => {
  const ogImageUrl = getNonWebpOgImageUrl(data.ogImage);

  return (
    <NextSeo
      title={data.title}
      defaultTitle='Parcel Monitor'
      description={data.description}
      noindex={data.robots?.includes('noindex')}
      nofollow={data.robots?.includes('nofollow')}
      canonical={data.ogUrl}
      openGraph={{
        type: data.ogType,
        url: data.ogUrl,
        title: data.ogTitle,
        description: data.ogDescription,
        images: [
          {
            url: ogImageUrl || '',
            alt: data.ogImage?.description,
          },
        ],
      }}
      twitter={{
        handle: '@ParcelPerform',
        site: '@ParcelPerform',
        cardType: 'summary_large_image',
      }}
      additionalLinkTags={[
        {
          rel: 'icon',
          href: '/favicons/favicon-32x32.png',
          type: 'image/png',
          sizes: '32x32',
        },
        {
          rel: 'icon',
          href: '/favicons/favicon-16x16.png',
          type: 'image/png',
          sizes: '16x16',
        },
      ]}
      additionalMetaTags={[
        {
          name: 'msapplication-TileColor',
          content: '#ffc03f',
        },
        {
          property: 'theme-color',
          content: '#ffffff',
        },
      ]}
    />
  );
};

export default DocumentHead;
